"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateEffect = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * 处理依赖更新时的副作用，等同于componentDidUpdate
 * @param callback
 * @param deps
 */
var useUpdateEffect = exports.useUpdateEffect = function useUpdateEffect(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var firstMount = _react.default.useRef(true);
  _react.default.useEffect(function () {
    if (firstMount.current) {
      firstMount.current = false;
    } else {
      callback();
    }
  }, deps);
};